import { Text } from "@chakra-ui/react";

export function Required () {
    return (
        <Text display="inline" color="red.500">
            *
        </Text>
    )
}
